import { IDateValidator } from './../../../services/calendar-service/date-validators/date-validator';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Workflow } from '../../../models';
import { ValidationResponse } from 'src/app/models/validation';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationError, WorkflowValidityModalComponent } from '../workflow-validity-modal/workflow-validity-modal.component';
import { Observable, Subscription } from 'rxjs';
import { WorkflowContextService, WorkflowService } from 'src/app/services';
import { Router } from '@angular/router';

@Component({
    selector: 'wm-workflow-list',
    templateUrl: './workflow-list.component.html',
    styleUrls: ['./workflow-list.component.css'],
    standalone: false
})
export class WorkflowListComponent implements OnInit {
  // Selected client, can be null;
  @Input() workflows: Workflow[];
  @Input() showAdmin = true;
  @Input() title = '';
  @Input() clientId: string;
  @Input() loadGlobal = false;
  @Input() isTemplateLibrary = false;
  
  @Output() onRestore: EventEmitter<string> = new EventEmitter<string>();
  @Output() onDisable: EventEmitter<string> = new EventEmitter<string>();
  @Output() onEnable: EventEmitter<string> = new EventEmitter<string>();
  @Output() onPublish: EventEmitter<string> = new EventEmitter<string>();
  @Output() onHistory: EventEmitter<string> = new EventEmitter<string>();
  @Output() onCopy: EventEmitter<Workflow> = new EventEmitter<Workflow>();
  @Output() onArchive: EventEmitter<{
    id: string;
    archiveNotes: string;
  }> = new EventEmitter<{ id: string; archiveNotes: string }>();
  @Output() toggleVisible: EventEmitter<Workflow> = new EventEmitter<
    Workflow
  >();

  archiveNotes: string;
  isValidating = false;

  constructor(private modalService: NgbModal, private _context: WorkflowContextService, private _router: Router, private _workflowSvc: WorkflowService) { }

  canPublish(wf) {
    return wf.canPublish && wf.isEnabled && wf.areThereChangesNotPublished;
  }

  isPublished(wf) {
    return wf.isEnabled && wf.areThereChangesNotPublished;
  }

  ngOnInit() { }

  validationModalClickSub: Subscription;

  showValidationErrors(wf) {
    const modalRef = this.modalService.open(WorkflowValidityModalComponent, {
      ariaLabelledBy: 'modal-validity-title',
      size: 'lg'
    });

    const ve = JSON.parse(wf.validationErrors);

    modalRef.componentInstance.validity = ve;
    modalRef.componentInstance.workflowId = wf.id;

    if (this.validationModalClickSub) {
      this.validationModalClickSub.unsubscribe();
    }

    this.validationModalClickSub = modalRef.componentInstance.clickedError.subscribe(
      async (error: ValidationError) => {
        if (error.activity) {
          this.modalService.dismissAll();
          this._router.navigate([
            '/admin/workflow-builder',
            wf.id
          ], { queryParams: { activityId: error.activity.id, templateCode: error.dataEntity?.templateCode } });
        }
      }
    );
  }
}
